import { memo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { List } from 'shared/components/list'

import { partnerFlagsTranslation } from '../../translation'

import styles from './EmptyListItem.module.scss'

export const EmptyListItem = memo(() => {
  return (
    <List.Label className={styles.empty}>
      <Translation text={partnerFlagsTranslation.empty.title} span />
    </List.Label>
  )
})
